import createCachedSelector from 're-reselect';

import type { ReduxState } from 'app/redux/types';

import { stagesSortedByTournamentsGroupedByPromotionLevelSelector } from 'app/modules/Live/selectors/gridPresentation';

export const selectStagesSortedByGroupedTournamentsBySportId = (
  selectStagesSortedByTournamentsGroupedByPromotionLevel:
    typeof stagesSortedByTournamentsGroupedByPromotionLevelSelector,
) => {
  return createCachedSelector(
    selectStagesSortedByTournamentsGroupedByPromotionLevel,
    (_state: ReduxState, sportId: number) => sportId,
    (stagesWithHierarchyBySport, sportId) => {
      return stagesWithHierarchyBySport.get(sportId) || new Map();
    },
  )((_state, sportId) => sportId);
};
